<template>
  <div class="wizard">
    <h4>Wizard</h4>
  </div>
</template>

<script>
export default {
  name: 'Wizard'
}
</script>
